import { Route, Routes } from "react-router-dom";
import { RootLayout } from "@/layouts/RootLayout";
import { HomePage } from "@/pages/HomePage";
import { ProductPage } from "@/pages/ProductPage";
import { CanvasPage } from "@/pages/CanvasPage";
import { ComponentsPage } from "@/pages/ComponentsPage";
import { QualificationPage } from "@/pages/QualificationPage";
import { MarketplacePage } from "@/pages/MarketplacePage";
import { AgentUserInterfacePage } from "@/pages/AgentUserInterfacePage";
import { DocsPage } from "@/pages/DocsPage";
import { CloudPage } from "@/pages/CloudPage";
import { SolutionsPage } from "@/pages/SolutionsPage";
import { PricingPage } from "@/pages/PricingPage";
import { EnterprisePage } from "@/pages/EnterprisePage";
import { SecurityPage } from "@/pages/SecurityPage";
import { AboutPage } from "@/pages/AboutPage";
import { ContactPage } from "@/pages/ContactPage";
import { SupportPage } from "@/pages/SupportPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { LegalHubPage } from "@/pages/legal/LegalHubPage";
import { TermsPage } from "@/pages/legal/TermsPage";
import { PrivacyPage } from "@/pages/legal/PrivacyPage";
import { RefundsPage } from "@/pages/legal/RefundsPage";
import { CancellationPage } from "@/pages/legal/CancellationPage";
import { AcceptableUsePage } from "@/pages/legal/AcceptableUsePage";
import { CookiesPage } from "@/pages/legal/CookiesPage";

export function App() {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/product" element={<ProductPage />} />
        <Route path="/canvas" element={<CanvasPage />} />
        <Route path="/components" element={<ComponentsPage />} />
        <Route path="/qualification" element={<QualificationPage />} />
        <Route path="/marketplace" element={<MarketplacePage />} />
        <Route path="/agent-user-interface" element={<AgentUserInterfacePage />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/cloud" element={<CloudPage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/enterprise" element={<EnterprisePage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/legal" element={<LegalHubPage />} />
        <Route path="/legal/terms" element={<TermsPage />} />
        <Route path="/legal/privacy" element={<PrivacyPage />} />
        <Route path="/legal/refunds" element={<RefundsPage />} />
        <Route path="/legal/cancellation" element={<CancellationPage />} />
        <Route path="/legal/acceptable-use" element={<AcceptableUsePage />} />
        <Route path="/legal/cookies" element={<CookiesPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
